// !!!!!!!!!!!!!!!!!!!!Validation Schema of Order!!!!!!!!!!!!!!!!!
import * as Yup from "yup";

export const newSaleOrderValidationSchema = Yup.object({
  partner_id: Yup.number().required("Customer is required"),
  warehouse_id: Yup.number().required("warehouse is required"),
  payment_term_id: Yup.number(),
  partner_invoice_id: Yup.number(),
  partner_shipping_id: Yup.number(),
  currency_id: Yup.number(),
  pricelist_id: Yup.number(),
  order_line: Yup.array()
    .of(
      Yup.object().shape({
        product_id: Yup.number().required("Product is required"),
        product_uom_qty: Yup.number()
          .min(1, "Quantity must be greater than or equal to 1")
          .required("Quantity is required"),
        price_unit: Yup.number()
          .required("Price is required"),
        discount: Yup.number()
          .min(0, "Discount must be greater than or equal to 0")
          .max(Yup.ref("price_total"), "Discount cannot exceed total amount")
          .required("Discount is required"),
      })
    ),
});


